import api from "../api/axios";

// baseURL is just the host, e.g. "https://qgjb21p0-8000.inc1.devtunnels.ms/"
// — no /api to strip. Media files are served off this same host root.
const API_HOST = (api.defaults.baseURL || "").replace(/\/+$/, "");

export function resolveMediaUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_HOST}${path.startsWith("/") ? "" : "/"}${path}`;
}